import type { Profile } from '../services/auth';

export const getDefaultNickname = (data: Profile | null) => {
  const { nickname, displayName } = data || {};

  if (nickname) {
    return nickname;
  }
  if (displayName) {
    return displayName;
  }

  return '';
};

export const hidePartOfNumberWithSymbol = (number: string, code = '1') => {
  if (!number) {
    return `+${code}**********`;
  }
  return `+${code}*******${number.slice(6, number.length)}`;
};

// Billing fields the payments backend requires before a purchase, deposit or redeem. Collect them
// up front (personal details dialog) instead of letting the payments iframe fail.
// `territory.code` is the state/province — null on a country-level placeholder territory.
export const isBillingProfileComplete = (profile: Profile | null | undefined) => {
  const { firstName, territory, city, address, zipCode, email, dateOfBirth } = profile || {};

  return Boolean(firstName && territory?.code && city && address && zipCode && email && dateOfBirth);
};
